// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eE32","delete":"styles_delete__1BG1v","update":"styles_update__w-p3l","add":"styles_add__1TgiS"};